export const MIXPANEL_ENVIRONMENT_PLACEHOLDER = '###MIXPANEL_ENVIRONMENT###'
